import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

import Identity from './identity';
import { headers, logPrefix } from './constants';

import { GdprReportStatus } from './gdpr';

/**
 * Gets the logged-in user's list of requested GDPR reports. In order to request a report to populate this response, the user should contact a customer service representative who can generate a report usinig private CSR APIs.
 *
 * @returns
 * A __Promise__ resolving to an array of requested report statuses.
 *
 * <details>
 * <summary>
 * On success (resolves)
 * </summary>
 *
 * ```json
 * [{
 *   "id": 4216698106919999,
 *   "requestDate": 1560801548000,
 *   "availableUntil": 1561406348000,
 *   "ready": true
 * }]
 * ```
 *
 * </details>
 *
 *
 */
export default async function listGdprReports(): Promise<
  Array<GdprReportStatus> | APIErrorResponse
> {
  const isLoggedIn = await Identity.isLoggedIn();
  if (!isLoggedIn) {
    throw new Error(`${logPrefix} Missing or invalid jwt`);
  }

  return fetch(`${Identity.apiOrigin}/identity/public/v1/gdpr?_=${Date.now()}`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${Identity.userIdentity.accessToken}`,
      ...headers
    }
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (Array.isArray(json)) {
        return json;
      } else {
        throw json;
      }
    });
}
